import { tokens } from "@core/theme/tokens";
import { ImageWithPlaceholder } from "@core/media";

// GATE-01-A (agent-logs/runs/2026-09-11-spec-219-offers/evidence/
// human-resolution-gate-01-dup-and-format.json): la caja de previsualización
// de imagen (132×82, borde sólido, "Sin imagen" cuando no hay URL) era el
// mismo marcado palabra por palabra en rewards/RewardsScreen.tsx y
// offers/OffersScreen.tsx. Cada pantalla conserva su propio contenedor
// punteado y el resto de su flujo (Reemplazar en Recompensas, input directo
// en Ofertas), que sí difiere. Extracción sin cambio de comportamiento ni de
// valores visuales: ninguna pantalla que la use cambia un pixel por esto.
// PLAN revisión-live-2026-09-22 #23: converge sobre `ImageWithPlaceholder`
// (`@core/media`) para agregar el manejo de `onError` que faltaba (URL
// guardada que no carga) sin cambiar tamaño ni borde de esta caja — 132×82
// entra en el umbral de texto de 11px.
export function ImagePreviewBox({ imageUrl }: { imageUrl: string }) {
  return (
    <ImageWithPlaceholder
      src={imageUrl}
      imageStyle={{
        width: 132,
        height: 82,
        objectFit: "cover",
        borderRadius: 9,
        border: `1px solid ${tokens.surface.line}`,
        flex: "none",
      }}
    />
  );
}
